import React, { useState } from "react";

import { DateTime } from "luxon";

export const SingleBookingDetailsList = ({ props, id }: any) => {
  const { first_name, total_bookings, experts, isSubscription, email, phone } =
    props;
  const loggedInUserEmail = localStorage.getItem("logged_in_email");

  const getLatestBooking = (bookings: any[]) => {
    if (bookings.length === 0) return "";

    const bookingsWithDateTime = bookings.map((booking) => {
      const dateTime = DateTime.fromFormat(
        `${booking.session_date} ${booking.session_time}`,
        "MM/dd/yyyy h:mm a"
      );
      return { ...booking, dateTime };
    });

    const sortedBookings = bookingsWithDateTime.sort(
      (a, b) => b.dateTime - a.dateTime
    );

    const latestBooking = sortedBookings[0];

    const formattedDate = latestBooking.dateTime.toFormat("d/LLL/yy - hh:mm a");

    return formattedDate;
  };

  const allowedEmails = ["tamannar@manoshala.com", "community@manoshala.com"];

  const isLoggedInUserAllowed =
    loggedInUserEmail !== null && allowedEmails.includes(loggedInUserEmail);

  return (
    <React.Fragment key={id}>
      {experts.map((expert: any, expertIndex: any) => (
        <React.Fragment key={expertIndex}>
          <tr key={expertIndex}>
            {expertIndex === 0 && (
              <td rowSpan={experts.length}>{first_name}</td>
            )}
            {expertIndex === 0 && <td rowSpan={experts.length}>{email}</td>}
            {expertIndex === 0 && isLoggedInUserAllowed && (
              <td rowSpan={experts.length}>{phone}</td>
            )}
            {expertIndex === 0 && (
              <td rowSpan={experts.length}>{isSubscription ? "Yes" : "No"}</td>
            )}
            {expertIndex === 0 && (
              <td rowSpan={experts.length}>{total_bookings}</td>
            )}

            <td>{expert.full_name}</td>
            <td>{expert.bookings_count}</td>
            <td>{getLatestBooking(expert.bookings)}</td>
          </tr>
        </React.Fragment>
      ))}
    </React.Fragment>
  );
};
